module.exports = __webpack_public_path__ + "img/kuyucuk-5.928c47ac.jpg";